// extracted by mini-css-extract-plugin
export default {"articleText":"articletext_articleText__RCvH3"};